import React from 'react';
import styled from '@emotion/styled';
import { theme } from '../../styles/theme';

const BillingToggle = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${theme.spacing['2xl']};
`;

const ToggleTrack = styled.div`
  position: relative;
  display: inline-flex;
  align-items: stretch;
  min-width: 260px;
  height: 44px;
  padding: 4px;
  background: var(--login-form-input-bg);
  border: 1px solid var(--login-form-border);
  border-radius: 999px;
`;

const SlidingPill = styled.div`
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 4px;
  width: calc(50% - 4px);
  background: var(--login-primary);
  border-radius: 999px;
  transform: translateX(${(props) => (props.$isYearly ? '100%' : '0')});
  transition: transform 0.3s ease;
  pointer-events: none;
`;

const ToggleOption = styled.button`
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.xs};
  min-width: 0;
  padding: 0 ${theme.spacing.md};
  background: transparent;
  border: none;
  border-radius: 999px;
  font-family: inherit;
  font-size: ${theme.typography.fontSize.sm};
  font-weight: 600;
  line-height: 1;
  color: ${(props) => (props.$isActive ? '#fff' : 'var(--login-form-muted)')};
  cursor: pointer;
  position: relative;
  z-index: 1;
  transition: color 0.2s ease;

  &:hover {
    color: ${(props) => (props.$isActive ? '#fff' : 'var(--login-form-text)')};
  }
`;

const SaveBadge = styled.span`
  padding: 2px 8px;
  border-radius: 999px;
  font-size: ${theme.typography.fontSize.xs};
  font-weight: 700;
  background: rgba(255, 255, 255, 0.22);
  color: inherit;
`;

const SaveBadgeMuted = styled.span`
  padding: 2px 8px;
  border-radius: 999px;
  font-size: ${theme.typography.fontSize.xs};
  font-weight: 700;
  background: rgba(72, 138, 236, 0.12);
  color: var(--login-primary);
`;

export default function PricingBillingToggle({ isYearly, onChange, savePercent = 20 }) {
  return (
    <BillingToggle>
      <ToggleTrack role="group" aria-label="Billing cycle">
        <SlidingPill $isYearly={isYearly} aria-hidden />
        <ToggleOption
          type="button"
          $isActive={!isYearly}
          onClick={() => onChange(false)}
          aria-pressed={!isYearly}
          aria-label="Monthly billing"
        >
          Monthly
        </ToggleOption>
        <ToggleOption
          type="button"
          $isActive={isYearly}
          onClick={() => onChange(true)}
          aria-pressed={isYearly}
          aria-label={`Yearly billing, save ${savePercent}%`}
        >
          Yearly
          {isYearly ? (
            <SaveBadge>Save {savePercent}%</SaveBadge>
          ) : (
            <SaveBadgeMuted>Save {savePercent}%</SaveBadgeMuted>
          )}
        </ToggleOption>
      </ToggleTrack>
    </BillingToggle>
  );
}
